<template>
    <HelloWorld msg="Welcome to Your Bar App"/>   
</template>
<script>
import HelloWorld from './HelloWorld.vue'

export default {
  name: 'Bar',
  components: {
    HelloWorld
  }
}
</script>